import React, { useEffect, useState, useContext, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import HeaderMobile from './Mobile';
import HeaderDesktop from './Desktop';
import { Header as StyledHeader } from './styles';
import { MediaContext } from '@spa/shared/contexts/media';
import { ProfileContext } from '@spa/shared/contexts/profile';
import LogoUniplaces from '@spa/shared/components/Header/Logo';

const Header = ({
  className,
  tabs,
  Logo = LogoUniplaces,
  handleAfterMenuIsToggled = () => {},
  hideUserTabs,
  isLoggedInOutsideOfContext = undefined,
  isSticky,
  hideHamburgerMenu,
  isGuestUnauthenticatedOutsideOfContext = undefined,
  onChangeLanguage,
  guestName
}) => {
  const { i18n } = useTranslation('header');
  const { is } = useContext(MediaContext);
  const changeLanguageHandler = useCallback(
    e => {
      i18n.changeLanguage(e.target.getAttribute('value'));
    },
    [i18n.language]
  );

  let isLoggedIn = isLoggedInOutsideOfContext;
  let isAccommodationProvider;
  let isGuestUnauthenticated = isGuestUnauthenticatedOutsideOfContext;
  if (isLoggedInOutsideOfContext === undefined) {
    const {
      isAccommodationProvider: isAccommodationProviderContext,
      isLoggedIn: isLoggedInContext,
      isGuestUnauthenticated: isGuestUnauthenticatedContext
    } = useContext(ProfileContext);

    isAccommodationProvider = isAccommodationProviderContext;
    isLoggedIn = isLoggedInContext;
    isGuestUnauthenticated = isGuestUnauthenticatedContext;
  }

  const Component = useMemo(() => (is.mobile ? HeaderMobile : HeaderDesktop), [is.mobile]);

  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => setHasMounted(true), []);

  if (!hasMounted) {
    return null;
  }

  return (
    <StyledHeader className={className}>
      <Component
        tabs={tabs}
        changeLanguageHandler={onChangeLanguage || changeLanguageHandler}
        updateLanguageByUrl={!!onChangeLanguage}
        isLoggedIn={isLoggedIn}
        isAccommodationProvider={isAccommodationProvider}
        handleAfterMenuIsToggled={handleAfterMenuIsToggled}
        Logo={Logo}
        hideUserTabs={hideUserTabs}
        isSticky={isSticky}
        hideHamburgerMenu={hideHamburgerMenu || isGuestUnauthenticated}
        guestName={guestName}
      />
    </StyledHeader>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.array,
  handleAfterMenuIsToggled: PropTypes.func,
  Logo: PropTypes.func,
  hideUserTabs: PropTypes.bool,
  isLoggedInOutsideOfContext: PropTypes.bool,
  isSticky: PropTypes.bool,
  hideHamburgerMenu: PropTypes.bool,
  isGuestUnauthenticatedOutsideOfContext: PropTypes.bool,
  onChangeLanguage: PropTypes.func,
  guestName: PropTypes.string
};

export default Header;
